<template>
  <v-menu
    v-model="show"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    no-title
    scrollable
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="placeholder"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" @input="show = false"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ["value", "placeholder"],
  data() {
    return {
      show: false,
      date: this.value
    };
  },
  watch: {
    value: {
      handler: function(val) {
        this.date = val;
      }
    },
    date: {
      handler: function(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
